import React, { useEffect, useState } from 'react';
import { ImageOff } from 'lucide-react';

/**
 * Small image preview. Shows a neutral tile when there is no URL or the image fails to load.
 * variant: '' (56x42) | 'lg' (96x72) | 'video' (96x54, 16:9) | 'wide' (full width, 16:9)
 */
const Thumb = ({ src, alt = '', variant = '', badge, className = '' }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [src]);

  const classes = ['adm-thumb', variant && `adm-thumb--${variant}`, className].filter(Boolean).join(' ');
  const showImage = Boolean(src) && !failed;

  return (
    <span className={classes}>
      {showImage ? (
        <img src={src} alt={alt} loading="lazy" decoding="async" onError={() => setFailed(true)} />
      ) : (
        <ImageOff aria-hidden="true" />
      )}
      {badge && <span className="adm-thumb__badge">{badge}</span>}
    </span>
  );
};

export default Thumb;
